import type { Nullable } from "../types";
import { guardString } from "./guard-string";

/**
 * An IBAN as it is printed and read aloud: in groups of four, `DE89 3704 0044 0532 0130 00`.
 * For display only — the database keeps the IBAN compact, without spaces, which is what a
 * comparison and a payment file need.
 *
 * @param iban - The IBAN, with or without spaces, in any case.
 * @returns The grouped IBAN in capitals, or the dash every empty field shows.
 */
export function formatIban(iban: Nullable<string>): string {
	const compact = iban?.replace(/\s+/g, "").toUpperCase();
	if (!compact) return guardString(null);
	return compact.replace(/(.{4})(?=.)/g, "$1 ");
}
